import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_LIABILITIES_SUCCESS:
      return [...action.liabilities];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/reducers/liabilities.js